import { render } from "./markdown.vue?vue&type=template&id=377cd4e7"
import script from "./markdown.vue?vue&type=script&lang=js"
export * from "./markdown.vue?vue&type=script&lang=js"

import "./markdown.vue?vue&type=style&index=0&id=377cd4e7&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__